<div style="margin-bottom: 1rem; margin-top: 3rem; display: flex; justify-content: end;">
  <div actions>
    <lib-button (click)="createOrganizationsModal()">Create Organization</lib-button>
  </div>
</div>

<div>
  <lib-container title="Organizations" style="width: 100%">

    <div>
      <!-- Loading State -->
      @if (loading) {
        <lib-content-loader></lib-content-loader>
      }

      <!-- Display table when there are organizations and loading is false -->
      @if (!loading && organizations.length > 0) {
        <table mat-table [dataSource]="organizations">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef style="font-weight: bold;">Name</th>
            <td mat-cell *matCellDef="let ref">{{ ref.name }}</td>
          </ng-container>

          <ng-container matColumnDef="approval">
            <th mat-header-cell *matHeaderCellDef style="font-weight: bold;">Approval</th>
            <td mat-cell *matCellDef="let ref">{{ ref.require_approval ? 'Yes' : 'No' }}</td>
          </ng-container>

          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let ref" class="table-actions">
              <lib-button mat-button color="accent" (click)="createOrganizationsModal(ref)">
                Edit
              </lib-button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns;"></tr>
        </table>
      }

      <!-- Display message when no organizations are found -->
      @if (!loading && organizations.length === 0) {
        <p>No organizations found</p>
      }
    </div>

  </lib-container>

</div>
